import { getFormattedAmount } from '@zonofi/common';
import { SVGS } from '@zonofi/zono-money-design-system';
import { OrderData, OrderStatusEnum } from '@zonofi/zono-money-helpers';
import React, { useMemo } from 'react';

interface OrderDetailsSummaryProps {
  orderDetails: OrderData;
  showOrderEdit: boolean;
  showPrice: boolean;
}

export const OrderDetailsSummary: React.FC<OrderDetailsSummaryProps> = ({
  orderDetails,
  showOrderEdit,
  showPrice,
}) => {
  let summary = [
    {
      name: 'Total Items',
      value:
        orderDetails?.lines?.length < 10
          ? orderDetails?.lines?.length.toString().padStart(2, '0')
          : orderDetails?.lines?.length,
    },
    {
      name: 'Total Quantity',
      value:
        orderDetails?.totalQuantity < 10
          ? orderDetails?.totalQuantity?.toString().padStart(2, '0')
          : orderDetails?.totalQuantity,
    },
    {
      name: 'Order Amount',
      value: getFormattedAmount(orderDetails?.subTotal),
    },
    {
      name: 'Scheme Savings',
      value: getFormattedAmount(-(orderDetails?.discount || 0)),
      color: '#2ABB7F',
    },
    {
      name: 'Gross Amount',
      value: getFormattedAmount(
        orderDetails?.subTotal - orderDetails?.discount
      ),
    },
    // {
    //   name: ' Amount',
    //   value: getFormattedAmount(orderDetails?.total - orderDetails?.discount),
    // },
    {
      name: 'GST Tax',
      value: getFormattedAmount(orderDetails?.tax),
      color: '#DD360C',
    },
    {
      name: 'Shipping Charges',
      value: getFormattedAmount(orderDetails?.shippingLines?.[0]?.price),
    },
    {
      name: 'Tax on shipping',
      value: `${getFormattedAmount((orderDetails?.shippingLines?.[0]?.priceWithTax ?? 0) - (orderDetails?.shippingLines?.[0]?.price ?? 0))}`,
    },
    {
      name: 'Net Order Amount',
      value: getFormattedAmount(orderDetails?.totalWithTax),
    },
  ];

  const showPrices = useMemo(
    () =>
      [
        OrderStatusEnum.DRAFT,
        OrderStatusEnum.ADDING_ITEMS,
        OrderStatusEnum.ORDER_CREATED,
        OrderStatusEnum.SUBMITTED_BY_SALES,
        OrderStatusEnum.SUBMITTED_BY_CFA,
        OrderStatusEnum.SUBMITTED_BY_CUSTOMER,
        OrderStatusEnum.SUBMITTED,
        OrderStatusEnum.ORDER_SUBMITTED,
        OrderStatusEnum.SUBMITTEDBYCUSTOMER,
        OrderStatusEnum.SUBMITTED_2,
      ].includes(orderDetails?.status as any)
        ? showPrice
        : true,
    [orderDetails, showPrice]
  );

  const summaryMemo = useMemo(() => {
    if (showOrderEdit || !showPrices) {
      return summary?.splice(0, 2);
    }
    return summary;
  }, [showOrderEdit, orderDetails, showPrices]);

  return (
    <div className="order-details-summary">
      <div className="order-details-summary-header font-primary-semibold">
        <img src={SVGS.NotesIcon} />
        <span>{showOrderEdit ? 'Requirement' : 'Bill Details'}</span>
      </div>
      <div className="order-details-summary-items font-primary">
        {summaryMemo?.map((item, i) => {
          return (
            <div className="order-details-summary-item" key={i}>
              <span>{item?.name}</span>
              <span>{item?.value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
